import React from "react";
import { useUser } from "@/base/components/auth/UserProvider";
import { useRouter } from "next/router";
import { Menu } from "antd";
import {
  getActiveKey,
  Items,
  ModifyRouteUrl,
} from "@/base/components/parts/header";
import { useTranslation } from "next-i18next";
import {
  MAX_L_DESKTOP,
  MAX_LAPTOP,
  useMediaQuery,
} from "@/base/utils/media.hook";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function DashboardLayout({ children, className }: Props) {
  const UserContext = useUser();
  const router = useRouter();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(MAX_LAPTOP);
  const isMediumPc = useMediaQuery(MAX_L_DESKTOP);

  return (
    <div
      className={`max-w-screen-2xl mx-auto w-full flex space-x-6 mt-6 px-4 ${className}`}
    >
      {!isMobile ? (
        <div>
          <Menu
            selectedKeys={[getActiveKey(router.route)]}
            mode="inline"
            //@ts-ignore
            items={Items.filter((item) => item.dashboard).map((item) => ({
              label: item.text(t),
              key: item.key,
              type: item.type,
              icon: <div className="py-1 flex">{item.icon(t)}</div>,
              size: "large",
            }))}
            className={`w-full sp-dashboard-menu ${
              isMediumPc && `[&_.ant-menu-title-content]:hidden`
            }`}
            onClick={({ key }) => {
              const item = Items.find((item) => item.key === key);
              router.push(
                ModifyRouteUrl(router, item?.url || router.pathname),
                undefined,
                {
                  shallow: item?.shadow || false,
                }
              );
            }}
          />
        </div>
      ) : null}
      <div className="flex-grow">{children}</div>
    </div>
  );
}
